import store from '~/store';
import type { proConfigItem } from '~/services/ProServer/types';
import ProServer from '~/services/ProServer';
import { NetCode, Token } from '~/types/const';
import useBasicStore from './basic';

const useProStore = defineStore('pro', ()=>{
    const proConfig = ref<proConfigItem[]>([])
    const globalProConfig = ref<proConfigItem[]>([])
    const proFuelBagConfig = ref<proConfigItem[]>([])
    const globalProFuelBagConfig = ref<proConfigItem[]>([])
    const isEnterpriseCatalogReady = ref(false)
    const currentCoin = ref('')
    async function getProConfig(){
        let res = await ProServer.getRequestProConfig()
        if(res.code === NetCode.SUCCESS){
            if (res.data && res.data.addOilPriceCfg) {
                proFuelBagConfig.value = res.data.addOilPriceCfg
            }
            if (res.data && res.data.globalAddOilPriceCfg) {
                globalProFuelBagConfig.value = res.data.globalAddOilPriceCfg
            }
            if (res.data && res.data.servicePriceCfg) {
                proConfig.value = res.data.servicePriceCfg
            }
            if (res.data && res.data.globalServicePriceCfg) {
                globalProConfig.value = res.data.globalServicePriceCfg
            }
            isEnterpriseCatalogReady.value = true
        }
    }

    return {
        proConfig,
        globalProConfig,
        proFuelBagConfig,
        globalProFuelBagConfig,
        isEnterpriseCatalogReady,
        getProConfig,
        currentCoin
    }
}, {
    persist:{
        pick: ['proConfig', 'globalProConfig'],
        storage: piniaPluginPersistedstate.localStorage(),
    }
})

export default useProStore
